/* global WeixinJSBridge */
// 拉起Wap JSAPI支付

/**
 * 
 * @param {String} appId 微信程序ID
 * @param {String} timestamp 
 * @param {String} nonce 
 * @param {String} packageStr 请求参数
 * @param {String} signType 加锁方式 
 * @param {String} sign 签名
 * @param {String} callback 回调
 */
function triggerWapPayment(appId, timestamp, nonce, packageStr, signType, sign, callback) {
    console.log(appId, timestamp, nonce, packageStr, signType, sign);
    WeixinJSBridge.invoke('getBrandWCPayRequest', {
        "appId": appId,
        //公众号名称，由商户传入     
        "timeStamp": timestamp,
        //时间戳，自1970年以来的秒数     
        "nonceStr": nonce,
        //随机串     
        "package": packageStr,
        "signType": signType,
        //微信签名方式：     
        "paySign": sign //微信签名 
    },
    callback);
}

function invokeWeixinBridge(method, params, callback) {
    if (typeof WeixinJSBridge === "undefined") {
        document.addEventListener("WeixinJSBridgeReady", () => {
            WeixinJSBridge.invoke(method, params, callback);
        }, false);
        return;
    }
    WeixinJSBridge.invoke(method, params, callback);
}

// 拉起微信商家转账/红包确认领取页
function triggerWechatTransfer(packageInfo, callback, options = {}) {
    const params = {
        "package": packageInfo
    };
    if (options.appId) {
        params.appId = options.appId;
    }
    if (options.mchId) {
        params.mchId = options.mchId;
    }

    invokeWeixinBridge("requestMerchantTransfer", params, callback);
}

export default {
    triggerWapPayment,
    triggerWechatTransfer
}
